import Helpers from "@/helpers.js"

export default {
  async filterIconToggle({ commit, dispatch, rootState }, data) {
    // Get appropriate timeline loading flag
    const timelineLoading = rootState.timeline.loading || false

    if (timelineLoading === false) {
      // Toggle enabled status
      commit('filterIconToggle', { enabled: data.enabled, id: data.id })
      // Get filtered events
      dispatch('getFilteredEvents', { loadMore: false, perPage: data.perPage, page: data.page, timelineType: data.timelineType, dateFrom: data.dateFrom, dateTo: data.dateTo })
    }
  },
  async filterDateRange({ commit, dispatch }, data) {
    // Update date filter state values
    commit('setFilterDateRange', data)
    // Get filtered events
    dispatch('getFilteredEvents', { loadMore: false, perPage: data.perPage, page: data.page, timelineType: data.timelineType })
  },
  async setupTimeline({ commit }, { timelineType }) {
    commit("resetTimeline")
    commit("setCurrentTimelineType", timelineType)
  },
  async getFilteredEvents({ commit, rootState, state }, data) {
    // Set timeline as loading
    commit('setTimelineLoading', true)
    const timelineEventMutation = (data.loadMore === false) ? 'setCurrentTimeline' : 'appendCurrentTimeline'
    const timelineType = data.timelineType || state.currentType

    // Get preferences
    const userPreferences = rootState.currentUser.me.preferences
    const timelineFilterPreferences = userPreferences.timeline

    const criteria = {
      page: data.page,
      pageSize: 10,
      dateTo: data.dateTo,
      dateFrom: data.dateFrom,
      showConversations: timelineFilterPreferences.conversations,
      showCreated: timelineFilterPreferences.created,
      showDocuments: timelineFilterPreferences.documents,
      showParticipants: timelineFilterPreferences.participants,
      showStateChanges: timelineFilterPreferences.stateChanges,
      showTasks: timelineFilterPreferences.tasks,
      showUpdates: timelineFilterPreferences.updates,
      showViewed: timelineFilterPreferences.viewed,
      showNotes: timelineFilterPreferences.notes
    }

    // Update timeline data
    let timelineEvents
    if (timelineType === "user") {
      timelineEvents = await rootState.provider.getUserTimeline(rootState.currentUser.me.id, criteria)
    } else {
      const caseId = data.caseId || rootState.cases.currentlySelected.case.id
      const caseTypeId = rootState.cases.currentlySelected.case.caseTypeId
      const excludedCaseTypeIds = rootState.caseTypes.all.map(ct => ct.id).filter(ctId => ctId !== caseTypeId)
      criteria.excludedCaseTypeIds = excludedCaseTypeIds

      timelineEvents = await rootState.provider.findCaseTimeline(caseId, criteria)
    }

    // Set new timeline events and format
    Helpers.adjustTimelineCaseTypeDisplayName(rootState, timelineEvents)
    commit(timelineEventMutation, timelineEvents)

    // Save new user preferences if not 'load more' action
    if (data.loadMore === false) {
      rootState.provider.updateUserPreferences({
        id: rootState.currentUser.me.id,
        userPreferences: {
          dateTimeFormat: userPreferences.dateTimeFormat,
          dateFormat: userPreferences.dateFormat,
          pageSize: 10,
          unifiedSearch: userPreferences.unifiedSearch !== false,
          timeline: {
            updates: timelineFilterPreferences.updates,
            viewed: timelineFilterPreferences.viewed,
            created: timelineFilterPreferences.created,
            participants: timelineFilterPreferences.participants,
            conversations: timelineFilterPreferences.conversations,
            stateChanges: timelineFilterPreferences.stateChanges,
            tasks: timelineFilterPreferences.tasks,
            documents: timelineFilterPreferences.documents
          }
        }
      })
    }

    commit('setTimelineLoading', false)
  }
}
